<div class="flex flex-row gap-3" [formGroup]="scheduleForm">
  <div class="flex flex-column">
    <div>
      <label for="frequency" class="block font-bold mb-2">Frequency</label>
      <div class="flex align-items-center" *ngFor="let period of periods">
        <p-radioButton
          [value]="period.value"
          formControlName="period"
          [inputId]="period.name"
        ></p-radioButton>
        <label [for]="period.name" class="ml-2">{{ period.name }}</label>
      </div>
    </div>
  </div>

  <div class="flex flex-column gap-3" *ngIf="scheduleForm.value.period != 0">
    <div class="flex flex-row">
      <div>
        <label for="startDate" class="block font-bold mb-2">Start Date</label>
        <p-datepicker
          inputId="startDate"
          formControlName="startDateTime"
          showIcon="true"
          dataType="string"
          dateFormat="mm/dd/yy"
          required="true"
          appendTo="body"
        >
        </p-datepicker>
      </div>
      <div>
        <label for="endDate" class="block font-bold mb-2">End Date</label>
        <p-datepicker
          inputId="endDate"
          formControlName="endDateTime"
          showIcon="true"
          dataType="string"
          dateFormat="mm/dd/yy"
          required="true"
          appendTo="body"
        >
        </p-datepicker>
      </div>
      <div>
        <label for="time" class="block font-bold mb-2">Time</label>
        <p-datepicker
          inputId="time"
          formControlName="time"
          [showIcon]="true"
          dataType="string"
          required="true"
          timeOnly="true"
          (onBlur)="onTimeChanged()"
          appendTo="body"
        >
          <ng-template pTemplate="footer">
            <div class="flex align-items-center justify-content-center">
              <p-button outlined="true" class="m-2 p-1" (click)="setNow()"
                >Now</p-button
              >
            </div>
          </ng-template>
        </p-datepicker>
      </div>
    </div>

    <div *ngIf="scheduleForm.value.period == 2">
      <label for="day" class="block font-bold mb-2">Day</label>
      <p-multiSelect
        [options]="allDaysOfWeek"
        formControlName="daysOfWeek"
        [filter]="false"
        optionLabel="name"
        placeholder="Select days"
        appendTo="body"
      ></p-multiSelect>
    </div>

    <div class="flex flex-row align-items-center gap-3">
      <div
        *ngIf="scheduleForm.value.period == 3 || scheduleForm.value.period == 4"
      >
        <label for="day" class="block font-bold mb-2">Day</label>
        <p-multiSelect
          [options]="allDaysInMonth"
          formControlName="daysOfMonth"
          [filter]="false"
          optionLabel="name"
          placeholder="Select days"
          appendTo="body"
        ></p-multiSelect>
      </div>

      <div *ngIf="scheduleForm.value.period == 4">
        <label for="day" class="block font-bold mb-2">Month</label>
        <p-multiSelect
          [options]="allMonths"
          formControlName="months"
          [filter]="false"
          optionLabel="name"
          placeholder="Select months"
          appendTo="body"
        ></p-multiSelect>
      </div>
    </div>
  </div>
</div>
